enum landingState {
  maf = 'maf',
  demoStage = 'demoStage',
  default = 'default',
}

export default landingState;
